import React from "react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/10 pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 lg:px-14">
        {/* Giant brand logo (single instance — replaces the duplicated text wordmark) */}
        <div className="mb-14 sm:mb-20">
          <img
            src="https://customer-assets.emergentagent.com/job_momenta-works/artifacts/rx6m3rj4_MOMENTA%20STUDIOS%20WHITE.png"
            alt="Momenta Studios"
            className="w-full max-w-[640px] h-auto object-contain select-none"
            data-testid="footer-brand-logo"
            draggable={false}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 border-t border-white/10 pt-10">
          <div className="md:col-span-4">
            <div className="eyebrow mb-3">The Studio</div>
            <p className="text-white/60 text-sm font-light leading-relaxed max-w-sm">
              A production house based in Mumbai, making photographs and films
              for food, products, events, and brand stories.
            </p>
          </div>

          <div className="md:col-span-2 md:col-start-6">
            <div className="eyebrow mb-3">Links</div>
            <ul className="space-y-2 text-white/70 font-light text-sm">
              <li><a href="#work" className="link-underline">Work</a></li>
              <li><a href="/films" className="link-underline">Ad Films</a></li>
              <li><a href="#about" className="link-underline">About</a></li>
              <li><a href="#team" className="link-underline">Crew</a></li>
              <li><a href="#contact" className="link-underline">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4 md:col-start-9">
            <div className="eyebrow mb-3">Contact</div>
            <a
              href="mailto:hello@momentastudios.in"
              className="font-serif italic text-white text-lg link-underline block"
            >
              hello@momentastudios.in
            </a>
            <div className="mt-2 text-white/60 text-sm font-light">
              Mumbai, India
            </div>
          </div>
        </div>

        <div className="mt-14 flex items-center justify-between flex-wrap gap-4 text-white/40 text-[10px] tracking-[0.3em] uppercase font-mono">
          <div>© {new Date().getFullYear()} Momenta Studios · All rights reserved</div>
          <div>Every Second, A Story · Mumbai</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
